import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import { JwtService } from 'src/app/auth/services';
import { SharedService } from 'src/app/shared/services';
import { EmailChannelService } from '../../services';
import {EmailChannel} from '../../models';
import { User } from 'src/app/auth/models';
@Component({
  selector: 'app-email-channel',
  templateUrl: './email-channel.component.html',
  styleUrls: ['./email-channel.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class EmailChannelComponent implements OnInit {
  dialogPosition = 'topright';
  distributionEmail;
  selectedGridMenuItem: any = null;
  items: MenuItem[];
  isDistributionEmailSettingsEdit:boolean = false;
  distributionEmailSettingsForm:FormGroup;
  loggedInUserProfile: User;
  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'emailChannel', header: 'Email Channel' },
    { value: 'isActive', header: 'Send To Distribution Email' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedBy', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'emailChannel', header: 'Email Channel' },
    { value: 'isActive', header: 'Send To Distribution Email' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedBy', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;
  constructor(
    private emailChannelService: EmailChannelService,
    private _router: Router,
    private _fb: FormBuilder,
    public sharedService: SharedService,
    private jwtService: JwtService,
    private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.items = [];
    this.checkViewPermission();
    this.checkEditPermission();
    this.getDistributionEmailSettings();
    this.getLoggedInUserProfile();
  }
  InitialSetup(){
    this.distributionEmailSettingsForm = this._fb.group({
      settingId: new FormControl(0),
      description: new FormControl(""),
      sendToDistributionEmail: new FormControl(),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }
  checkViewPermission() {
    var permission = this.jwtService.getLoggedInUserProfile();
    if (permission == 0) {
      this._router.navigateByUrl('/login');
    }
  }
  checkEditPermission()
  {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    if (isAdminAdd) {
      var editItem = {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: e => this.editDistributionEmailSettings(this.selectedGridMenuItem.settingId),
      }
      this.items.push(editItem);
    }
  }
  getLoggedInUserProfile()
  {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }
  getDistributionEmailSettings()
  {
    this.emailChannelService.getDistributionEmailSettings().subscribe((data:any)=>{
    this.distributionEmail= data;
    });
  }
  editDistributionEmailSettings(settingId:number)
  {
    this.isDistributionEmailSettingsEdit = true;
    this.InitialSetup();
    this.emailChannelService.getDistributionEmailById(settingId).subscribe((data:any)=>{
      this.distributionEmailSettingsForm.patchValue(data);
    });
  }
  save({value}: {value: EmailChannel}){
    console.log(value);
    var settingId = value.settingId;
    value.modifiedBy = Number(this.loggedInUserProfile.uid);
    this.emailChannelService.putDistributionEmailById(settingId,value).subscribe((data:any)=>{
      this.messageService.add({severity:'success', summary:'Confirmed', detail:'Distribution email settings updated successfully'});
      this.getDistributionEmailSettings();
      this.isDistributionEmailSettingsEdit = false;
    });
  }
  cancel()
  {
    this.isDistributionEmailSettingsEdit = false;
  }
}
